/* src/app/components/payroll/claim-adjustment/billing-claim-adjustment/billing-claim-adjustment.component.css */
.ppl-nav-link.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
/*# sourceMappingURL=billing-claim-adjustment.component-YRJEPPBQ.css.map */
